export const ME_ENDPOINT = {
    method: 'GET',
    path: '/api/v1/auth/me',
};
//# sourceMappingURL=me.js.map